import { MemberSetModel } from "@app/members";
import { SpecialtyOverrides } from "@app/projects/create/interfaces";
import EditProjectOverrideMemberSet from "@app/projects/editProjectOverrideMemberSet";
import { MemberTable } from "@app/projects/MemberTable";
import { MembershipBindingTable } from "@app/projects/network-assessment/EditMembershipBindingTable";
import { TemplateSpecialtyGroup } from "@app/templates";
import sortBy from "lodash/sortBy";
import * as React from "react";
import { RouteComponentProps } from "react-router-dom";
import Project from "@app/projects/project";

interface MemberOptionsProps {
  checkboxClass: string;
  disabled: boolean;
  handleMemberPopAliasChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleMemberPopAliasChange2: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleMemberPopChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  handleMemberPopChange2: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  handleRiskPopChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  onAddAlternateRow: () => void;
  onAlternateMemberPopAliasChange: (rows: EditProjectOverrideMemberSet[]) => void;
  onAlternateMemberPopChange: (memberPopId: number, prevMemberPopId: number) => void;
  onCheckBoxChange: (property: UpdateResourceKeys) => void;
  onDeleteAlternateRow: (rows: EditProjectOverrideMemberSet[]) => void;
  onSpecialtyGroupsChange: (selectedRecords: TemplateSpecialtyGroup[]) => void;
  project: Project;
  projectMemberPopulations: MemberSetModel[];
  shared: boolean;
  sortedSpecialtyGroups: TemplateSpecialtyGroup[];
  allMemberPopulations: MemberSetModel[];
  alternateMemberships: MemberSetModel[];
  defaultOpen?: boolean;
  disableMemberBindingTable: boolean;
  generateAlternateMemberships: () => void;
  handlePrimaryMembershipBindingChange: (memberPop: number, code: string) => void;
  handleSecondaryMembershipBindingChange: (memberPop: number, code: string) => void;
  setPrimarySpecialtyOverride: (memberPop: number, code: string) => void;
  setSecondarySpecialtyOverride: (memberPop: number, code: string) => void;
  specialtyGroups: TemplateSpecialtyGroup[];
  specialtyOverrides: SpecialtyOverrides[];
  isZipProject: boolean;
}

interface MemberOptionsState {
  sortedSpecialtyGroups: TemplateSpecialtyGroup[];
}

type UpdateResourceKeys = keyof Project;

type CombinedMemberOptionProps = MemberOptionsProps & RouteComponentProps;

class MemberOptions extends React.Component<CombinedMemberOptionProps, MemberOptionsState> {

  private readonly sortOrder: Array<keyof TemplateSpecialtyGroup> = ["displayOrder"];

  constructor(props: CombinedMemberOptionProps) {
    super(props);
    this.state = {
      sortedSpecialtyGroups: props.specialtyGroups && sortBy(props.specialtyGroups, this.sortOrder) || props.specialtyGroups,
    };
  }

  public componentDidUpdate(prevProps: CombinedMemberOptionProps) {
    if (this.props.specialtyGroups !== prevProps.specialtyGroups) {
      this.setState({
        sortedSpecialtyGroups: this.props.specialtyGroups && sortBy(this.props.specialtyGroups, this.sortOrder) || this.props.specialtyGroups,
      });
    }
  }

  public render() {
    const adequacyTemplateComplete = (!!this.props.project.adequacyTemplateCollectionId &&
      !!this.props.project.adequacyTemplateCorrelationId &&
      this.props.project.adequacyTemplateCorrelationId !== "");
    if (!adequacyTemplateComplete) {
      return (
        <React.Fragment>
          <div className="col-12 col-sm-9 col-lg-9">
            <p>
              The project options you have selected do not allow configuration of memberships. This can occur if you have not yet selected a
              network assessment analysis template or selected only an accuracy template. If you intended to analyze against membership populations,
              please return to the Template tab and change your selections.
            </p>
          </div>
        </React.Fragment>
      );
    }
    return (
      <React.Fragment>
        <div className="form-group row tab-contents col-12">
          <div className="col-12">
            <MemberTable
              {...this.props}
              handleMemberPopChange={this.props.handleMemberPopChange}
              handleMemberPopAliasChange={this.props.handleMemberPopAliasChange}
              handleMemberPopChange2={this.props.handleMemberPopChange2}
              handleMemberPopAliasChange2={this.props.handleMemberPopAliasChange2}
              onAlternateMemberPopChange={this.props.onAlternateMemberPopChange}
              onAlternateMemberPopAliasChange={this.props.onAlternateMemberPopAliasChange}
              onAddAlternateRow={this.props.onAddAlternateRow}
              onDeleteAlternateRow={this.props.onDeleteAlternateRow}
              handleRiskPopChange={this.props.handleRiskPopChange}
              disabled={this.props.disabled}
              generateAlternateMemberships={this.props.generateAlternateMemberships}
              project={this.props.project}
              shared={this.props.shared}
              projectMemberPopulations={this.props.projectMemberPopulations}
              allowAlternates={true}
            />
          </div>

          {this.state.sortedSpecialtyGroups && this.state.sortedSpecialtyGroups.length > 0 && !this.props.disableMemberBindingTable && (
            <div className="col-12">
              <div>
                <MembershipBindingTable
                  allMemberPopulations={this.props.allMemberPopulations}
                  alternateMemberships={this.props.alternateMemberships}
                  canEdit={!this.props.shared}
                  projectModel={this.props.project}
                  excludedSpecialtyGroupCodes={this.props.project.excludedSpecialtyGroupCodes}
                  specialtyGroups={this.props.specialtyGroups}
                  uniqueKey={`${this.props.project.adequacyTemplateCollectionId}${this.props.project.adequacyTemplateCorrelationId}`}
                  projectMemberPopulations={this.props.projectMemberPopulations}
                  handlePrimaryMembershipBindingChange={this.props.handlePrimaryMembershipBindingChange}
                  handleSecondaryMembershipBindingChange={this.props.handleSecondaryMembershipBindingChange}
                  setPrimarySpecialtyOverride={this.props.setPrimarySpecialtyOverride}
                  setSecondarySpecialtyOverride={this.props.setSecondarySpecialtyOverride}
                  shared={this.props.shared}
                  specialtyOverrides={this.props.specialtyOverrides}
                  editProjectOverridesMembersets={this.props.project.editProjectOverrideMemberSets}
                />
              </div>
            </div>
          )}
        </div>
      </React.Fragment>
    );
  }
}

export { MemberOptions };
